import OrganizationForm from '@/components/organizations/OrganizationForm'
import { Organization } from '@/types'
import { Head } from '@inertiajs/react'

export default function OrganizationEdit({ organization }: { organization: Organization }) {
  return (
    <>
      <Head title={`Modifier ${organization.name}`} />
      <OrganizationForm organization={organization} />
    </>
  )
}
